const REAL = {
  nightPour: "https://customer-assets-jai6qajn.emergentagent.net/job_construct-solar-hub/artifacts/uutmj6d6_IMG-20260923-WA0065.jpg",
  towersModel: "https://customer-assets-jai6qajn.emergentagent.net/job_construct-solar-hub/artifacts/ss2u1l2d_IMG-20260923-WA0066.jpg",
  surveying: "https://customer-assets-jai6qajn.emergentagent.net/job_construct-solar-hub/artifacts/4xvfuntk_IMG-20260923-WA0067.jpg",
  slabdeck: "https://customer-assets-jai6qajn.emergentagent.net/job_construct-solar-hub/artifacts/zhcnk1u2_IMG-20260923-WA0068.jpg",
  rebarAerial: "https://customer-assets-jai6qajn.emergentagent.net/job_construct-solar-hub/artifacts/klbsvdmt_IMG-20260923-WA0069.jpg",
};

export const PROJECTS = [
  {
    id: "jawahiry-bridge",
    title: "مدينة جواهري",
    category: "roads",
    categoryLabel: "طرق وجسور",
    location: "منطقة التازة",
    client: "تطوير فكرة بغداد",
    image: "/images/projects/jawahiry.jpg",
    excerpt:
      "مشروع مدينة جواهري المتكامل — هندسة مدنية ثقيلة وبنية تحتية لممر تجاري استراتيجي يربط القطاعات الصناعية الحيوية عبر منطقة التازة، بكمرات كونكريت مسبق الصب ودعائم معززة لتدفق البضائع الثقيلة.",
    story: [
      "تمثل مدينة جواهري أحد أبرز أعمال الهندسة المدنية الثقيلة لدى فكرة بغداد — مجمع عمراني متكامل صُمم وأُنشئ ليكون ممراً تجارياً استراتيجياً يربط القطاعات الصناعية الحيوية عبر منطقة التازة، بمخطط عمراني حديث يوازن بين الكتل السكنية والمساحات الخضراء والساحات المركزية.",
      "اعتمد التنفيذ على كمرات كونكريت مسبق الصب عالية المقاومة ودعائم إنشائية معززة بهياكل وتائر مسلحة، ليستوعب الجسر العابر تدفق البضائع الثقيلة بكفاءة ويعزز الممرات التجارية الإقليمية، مع التزام كامل بمعايير السلامة الوطنية في كل مرحلة من مراحل الإنشاء.",
    ],
    highlights: [
      "كمرات كونكريت مسبق الصب عالية المقاومة",
      "دعائم معززة بهياكل وتائر مسلحة",
      "مصمم لتدفق البضائع الثقيلة",
      "مخطط عمراني متكامل بمساحات خضراء",
    ],
    gallery: [{ src: "/images/projects/jawahiry.jpg", caption: "الرندر الجوي لمخطط مدينة جواهري" }],
  },
  {
    id: "hawli-interchange",
    title: "تقاطع ومجسر طريق حولي",
    category: "roads",
    categoryLabel: "طرق وجسور",
    location: "كركوك — باتجاه الجامعة",
    client: "بالشراكة مع شركة طاسلي",
    image: "/images/projects/hawli.jpg",
    excerpt:
      "مشروع مجسر ربط طريق المطار باتجاه الجامعة — أنجزته فكرة بغداد بالشراكة مع شركة طاسلي لمعالجة الاختناقات المرورية بشكل جذري، بمجسرات علوية متطورة ومنحدرات دخول وخروج انسيابية.",
    story: [
      "مشروع حيوي لتطوير حركة النقل أنجزته شركة طاسلي وفكرة بغداد لمعالجة الاختناقات المرورية بشكل جذري في عقدة طريق حولي بمحافظة كركوك — أحد أكثر المحاور ازدحاماً باتجاه الجامعة وطريق المطار.",
      "يتضمن المشروع مجسرات علوية متطورة متعددة المستويات ومنحدرات دخول وخروج انسيابية مصممة هندسياً لتنظيم حركة السير وتعزيز السلامة المرورية، مع حلول نقل حضرية متقدمة تختصر زمن الرحلة اليومية لآلاف المركبات.",
    ],
    highlights: [
      "تقاطع متعدد المستويات بمجسرات علوية",
      "منحدرات دخول وخروج انسيابية",
      "حل جذري للاختناق عند عقدة طريق حولي",
      "تعزيز السلامة المرورية الحضرية",
    ],
    gallery: [{ src: "/images/projects/hawli.jpg", caption: "الرندر الهندسي للمجسر متعدد المستويات" }],
  },
  {
    id: "stormwater",
    title: "شبكة مياه الأمطار الاستراتيجية ومكافحة الفيضانات",
    category: "water",
    categoryLabel: "بنى تحتية",
    location: "بغداد — شارع التربية والمعامل، بوب الشام",
    client: "أمانة بغداد — عقد رسمي",
    image: "/images/projects/stormwater.jpg",
    excerpt:
      "مشروع ضخم لتصريف مياه الأمطار بعقد رسمي مع أمانة بغداد، يشمل شارع التربية وشارع المعامل (محلة 361 بوب الشام) — ركيزة لتطوير البنية الهيدروليكية وحماية أحياء العاصمة من الفيضانات الموسمية.",
    story: [
      "نجحت مجموعة فريدون عبر ذراعها التنفيذي شركة فكرة بغداد، وبموجب عقد رسمي مع أمانة بغداد، في تنفيذ مشروع شبكات ومشبكات مياه الأمطار في مناطق حيوية بالعاصمة، في مقدمتها شارع التربية وشارع المعامل (محلة 361 بوب الشام).",
      "يمثل هذا المشروع ركيزة أساسية لتطوير البنية التحتية الهيدروليكية للعاصمة — من مد القسائم العملاقة بالرافعات الثقيلة إلى الإدارة الحديثة للصرف الصحي — ليحمي أحياء بغداد من الفيضانات الموسمية ويرفع جاهزية شبكات التصريف لعقود قادمة.",
    ],
    highlights: [
      "عقد رسمي مع أمانة بغداد",
      "مد قسائم عملاقة برافعات ثقيلة",
      "شارع التربية وشارع المعامل — محلة 361",
      "حماية أحياء العاصمة من الفيضانات الموسمية",
    ],
    gallery: [{ src: "/images/projects/stormwater.jpg", caption: "أعمال مد القسائم العملاقة في موقع المشروع" }],
  },
  {
    id: "hamza-asphalt",
    title: "إكساء وتأهيل شارع حمزة",
    category: "roads",
    categoryLabel: "طرق وجسور",
    location: "بغداد",
    client: "دائرة مشاريع أمانة بغداد",
    image: "/images/projects/asphalt.jpg",
    excerpt:
      "أعمال تأسيس ورصف وإكساء إسفلتي للشوارع الرئيسية في العاصمة ومنها شارع الحمزة بمساحة تتجاوز 18,000 م²، بأحدث آليات الرصف الميكانيكية وبالتعاون مع دائرة مشاريع أمانة بغداد.",
    story: [
      "بالتعاون الوثيق مع دائرة المشاريع في أمانة بغداد، أنجزت فكرة بغداد مشروعاً استراتيجياً متكاملاً يتضمن أعمال التأسيس والرصف والإكساء الإسفلتي (فرش الأسفلت) للشوارع الرئيسية في العاصمة، ومنها شارع الحمزة بمساحة تتجاوز 18,000 متر مربع.",
      "نُفذ المشروع بأسطول ميكانيكي حديث من فريشات الأسفلت والهراسات الثقيلة، بدءاً من الأعمال الترابية وتحضير طبقة الأساس وصولاً إلى الفرش النهائي — ما ضمن متانة الطرق الحضرية ورفعها إلى المعايير الوطنية للسلامة وحسّن الحركة المرورية في العاصمة.",
    ],
    highlights: [
      "أكثر من 18,000 م² إكساء إسفلتي",
      "أسطول رصف ميكانيكي حديث بالكامل",
      "أعمال ترابية وتحضير أساس متكاملة",
      "بالتعاون مع دائرة مشاريع أمانة بغداد",
    ],
    gallery: [{ src: "/images/projects/asphalt.jpg", caption: "فريشة الأسفلت والهراسات أثناء التنفيذ" }],
  },
  {
    id: "jadriyah-towers",
    title: "أبراج الجادرية السكنية",
    category: "buildings",
    categoryLabel: "أبنية وتطوير",
    location: "بغداد — الجادرية",
    client: "تطوير فكرة بغداد",
    image: "/images/projects/jadriyah.jpg",
    excerpt:
      "برجان سكنيان متطابقان بأسلوب معماري مستقبلي في أرقى مناطق العاصمة — واجهات زجاجية منحنية، شرفات خضراء مستدامة، ساحة تجارية مركزية وإطلالات بانورامية على المدينة.",
    story: [
      "يُعتبر مشروع أبراج الجادرية السكني علامة فارقة في قطاع التطوير العقاري الفاخر بالعاصمة بغداد — برجان متطابقان بتصميم مستقبلي يعتمد على الواجهات الزجاجية المستمرة والهياكل البيضاء المتموجة التي تمنح المبنى هوية معمارية لا تُنسى.",
      "يهدف المشروع إلى ترسيخ معايير جديدة للمعيشة الحضرية الراقية: تصميم يدمج المسطحات الخضراء عبر الحدائق المعلقة والشرفات المستدامة، إطلالات بانورامية على المدينة، ساحات تجارية مركزية، ووصول خاص إلى الواجهة المائية — مع خدمات ترفيهية متكاملة وممرات مائية تعكس الطابع اللامع والفاخر للمجمع. وتوثق صور موقع العمل أدناه مراحل التنفيذ الفعلية من الشدات والتسليح حتى الصب الليلي.",
    ],
    highlights: [
      "برجان توأمان بواجهات زجاجية منحنية",
      "حدائق معلقة وشرفات خضراء مستدامة",
      "ساحة تجارية مركزية وواجهة مائية",
      "إطلالات بانورامية على بغداد",
    ],
    gallery: [
      { src: "/images/projects/jadriyah.jpg", caption: "الرندر المعماري للبرجين التوأمين" },
      { src: REAL.towersModel, caption: "الموديل الهندسي التفصيلي للمشروع" },
      { src: REAL.nightPour, caption: "أعمال الصب الليلية فوق سماء بغداد" },
      { src: REAL.slabdeck, caption: "الشدات السقفية SLABDECK قيد التركيب" },
      { src: REAL.surveying, caption: "أعمال المساحة الليلية بجهاز المحطة الشاملة" },
      { src: REAL.rebarAerial, caption: "تسليح السقوف فوق سماء المدينة" },
    ],
  },
  {
    id: "luxury-mall",
    title: "مول تجاري فاخر وجادة تسوق",
    category: "buildings",
    categoryLabel: "أبنية وتطوير",
    location: "العراق",
    client: "تطوير فكرة بغداد",
    image: "/images/projects/mall.jpg",
    excerpt:
      "مجمع المول التجاري وجادة التجزئة الفاخرة — عمارة حديثة تدمج الأشكال الهندسية المنحنية والأقواس المعمارية الكبرى، صُمم لاستضافة كبرى العلامات التجارية العالمية.",
    story: [
      "يجسد هذا المشروع العمارة التجارية الحديثة وتطوير مراكز التسوق النخبوية — تطوير تجاري بارز يدمج بعبقرية بين الأشكال الهندسية المنحنية والأقواس المعمارية الشاهقة ذات الطابع المستقبلي، ليصبح معلماً تجارياً يستقطب الزوار من كل أنحاء المنطقة.",
      "يمتد المشروع من مرحلة الهياكل الإنشائية الثقيلة إلى التشطيبات الجمالية الفاخرة، وقد صُمم خصيصاً لاستضافة كبرى العلامات التجارية العالمية، ليرسخ مكانته كوجهة إقليمية أولى للتجزئة الراقية والتجارة الحضرية العصرية.",
    ],
    highlights: [
      "أقواس معمارية شاهقة بطابع مستقبلي",
      "من الهياكل الإنشائية إلى التشطيبات الفاخرة",
      "مصمم لكبرى العلامات التجارية العالمية",
      "وجهة إقليمية للتجزئة الراقية",
    ],
    gallery: [{ src: "/images/projects/mall.jpg", caption: "واجهة المول التجاري بأقواسه المعمارية" }],
  },
];

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const resolveMedia = (src) =>
  !src ? "" : src.startsWith("http") || src.startsWith("/") ? src : `${API_BASE}/files/${src}`;
